import { useMutation, useQueryClient } from "@tanstack/react-query";
import { generateReview } from "../services/review.service";
import type { GenerateReviewRequest } from "../types/review.types";

export const useGenerateReview = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ request, signal }: { request: GenerateReviewRequest; signal: AbortSignal }) => {
      return generateReview(request, signal);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reviews"] });
    },
    onError: (error, variables) => {
      if (error.name === "CanceledError") {
        console.log("Review generation canceled for:", variables.request.query_term);
      } else {
        console.error(
          "Hook: Error generating review for:",
          variables.request.query_term,
          "Error:",
          error
        );
      }
    },
  });
};
